import type { FaireProductEntity } from "../../entity_types/product";

export const p_g9gywb5t6x: FaireProductEntity = {
  token: "p_g9gywb5t6x",
  type: "product",
  name: "24x24 Lina Linen Pillow Cumin",
  brandToken: "b_6jjy4txuzi",
  brandName: "Indaba Trading",
  imageUrl:
    "https://cdn.faire.com/fastly/da68c04b9b3bca101205e68b4e7798a579cb9cbc225a62fb734f39aad2853bfe.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/af74fc97b628d4bd2453e5755952195c37d024aa17d9b9e8dca205a2991cc777.jpeg",
    "https://cdn.faire.com/fastly/2c31271cd749cfc7630b027a113e7b0a9ad3a8714a30f7e38d2c8faf984afd56.jpeg",
    "https://cdn.faire.com/fastly/83f41cd8db551b02ed019b71b2d85c0d9098e6be26a8e569f715043697954994.jpeg",
    "https://cdn.faire.com/fastly/d8d6090d08b9bdca644b757a8ca2b5d49d3c9725c52c047cb61724c8b1b61437.jpeg",
  ],
  priceDollars: 58,
  description:
    "Lina Linen Decorative Pillow Handcrafted Style with Sustainable Materials\r\n\r\nElevate your space with the Lina Linen Decorative Pillow, a bestselling accent crafted from sustainable materials and designed for timeless layering. Perfect for style-conscious homes that value comfort and craftsmanship. Available with a premium RDS certified feather-down filler for fabulous fluff factor and comfort you'll want to sink your head into.\r\n\r\nMaterials & Composition: Made from 100% Belgian linen, enzyme washed for a relaxed, stonewashed look. Woven in India by skilled artisans and finished with a frayed edge. Colours may vary slightly due to small batched, hand-dyed processes.\r\n\r\nCare Instruction: Machine wash gentle cycle. Tumble dry low or lay flat to dry.\r\n\r\nFeatures & Benefits:\r\n- Artisan-made using sustainable materials\r\n- Soft, textured linen with frayed edges\r\n- Elegant standalone pillow or layering essential\r\n- A customer-favourite among decorative pillows",
  tags: [],
  msrpDollars: 116,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-05-06T18:10:59.930Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
